import React from 'react';

import { Text } from '../Text';
import { Button } from '../Button';
import { Header, HeaderGrid } from './styled';
import { HeaderVariant } from '../Text/types';
import { DownArrowIcon, UpArrowIcon, CrossIcon } from '../../icons';

type CardHeaderAction = {
  title: string;
  onClick: () => void;
};

export interface CardHeaderProps {
  id?: string;
  title?: string;
  subtitle?: string;
  headerVariant?: HeaderVariant;
  action?: CardHeaderAction;
  actionSlot?: React.ReactNode;
  isCollapsed?: boolean;
  onClickCollapse?: () => void;
  onClickClose?: () => void;
}

export const CardHeader = ({
  id,
  title,
  subtitle,
  headerVariant = 'headingSmall',
  action,
  actionSlot,
  isCollapsed,
  onClickCollapse,
  onClickClose,
}: CardHeaderProps) => (
  <Header>
    <HeaderGrid>
      <Text id={id} variant={headerVariant}>
        {title}
      </Text>
      {action && (
        <Button variant="link" onClick={action.onClick}>
          {action.title}
        </Button>
      )}
      {actionSlot}
      {onClickCollapse && (
        <Button
          variant="flat"
          iconSlot={isCollapsed ? <DownArrowIcon /> : <UpArrowIcon />}
          onClick={onClickCollapse}
        />
      )}
      {onClickClose && (
        <Button
          variant="flat"
          iconSlot={<CrossIcon />}
          onClick={onClickClose}
          aria-label="Close"
          type="button"
        />
      )}
    </HeaderGrid>
    {subtitle && <Text variant="subheadingSmall">{subtitle}</Text>}
  </Header>
);
